import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from 'tss-react/mui';

import { Topbar } from './components';
import { Outlet } from 'react-router-dom';

const useStyles = makeStyles()((theme) => ({
  root: {
    paddingTop: 56,
    height: '100%',
    [theme.breakpoints.up('sm')]: {
      paddingTop: 64,
    },
    [theme.breakpoints.up('xs')]: {
      paddingTop: 56,
    },
  },
  content: {
    height: '100%',
  },
}));

const Minimal = (props) => {
  const { showLoginBtn, showUserWelcomeMsg } = props;

  const { classes } = useStyles();

  return (
    <div className={classes.root}>
      <Topbar showLoginBtn={showLoginBtn} showUserWelcomeMsg={showUserWelcomeMsg} />
      <main className={classes.content}>
        <Outlet />
        {/* {children} */}
      </main>
    </div>
  );
};

Minimal.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
};

export default Minimal;
